import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { PricePipe } from './price.pipe';

@NgModule({
  declarations: [PricePipe],
  imports: [CommonModule],
  providers: [CurrencyPipe, PricePipe],
  exports: [PricePipe],
})
export class PipesModule {}
